// extracted by mini-css-extract-plugin
export default {"pages":"Pages_pages__fcFXP","page":"Pages_page__nXNmB","grid":"Pages_grid__lLB-r","fadeIn":"Pages_fadeIn__Hl5MW"};